import {
    useCustomerUtilityBillFilePdfPreviewQuery,
    useDownloadCustomerUtilityBillFilePdfMutation,
} from 'src/domain/customer-utility-bill-file/queries';
import { PdfPreviewPanel } from '../PdfPreviewPanel';

interface Props {
    // The bill's source file — a bill's PDF is the PDF of the file it was parsed from (same preview endpoint as the
    // file modal). `null` when the bill isn't linked to a file.
    fileId: string | null;
}

export const BillPdfPanel = ({ fileId }: Props) => {
    // `isInitialLoading` (not `isLoading`): with no fileId the query is disabled, and v4 reports a disabled query as
    // loading forever — we want the empty state instead.
    const { data: pdfUrl, isInitialLoading, isError } = useCustomerUtilityBillFilePdfPreviewQuery(fileId);
    const { mutate: downloadPdf, isLoading: isDownloading } = useDownloadCustomerUtilityBillFilePdfMutation();

    return (
        <PdfPreviewPanel
            pdfUrl={fileId ? pdfUrl : null}
            isLoading={isInitialLoading}
            isError={isError}
            onDownload={() => fileId && downloadPdf(fileId)}
            isDownloading={isDownloading}
            errorText="Could not load the bill PDF"
            emptyText="No PDF available for this bill"
        />
    );
};
